module.exports = __webpack_public_path__ + "assets/img/官方抖音-cec504df.png";